export const MAX_MB = 30;

export const MAX_FILE_SIZE = 1024 * 1024 * MAX_MB;
